define('MultipleAddToCartPLP.Cart.Confirmation.View', [
    'Backbone',
    'multipleaddtocartplp_confirmation.tpl',
    'Backbone.CollectionView',
    'MultipleAddToCartPLP.Cart.Confirmation.Line.View',
    'Utils',
    'underscore',
    'LiveOrder.Model'
], function MultipleAddToCartPLPCartConfirmationView(
    Backbone,
    multipleaddtocartplpConfirmationTpl,
    BackboneCollectionView,
    MultipleAddToCartPLPCartConfirmationLineView,
    Utils,
    _,
    LiveOrderModel
) {
    'use strict';

    return Backbone.View.extend({

        title: Utils.translate('Added to Cart'),

        page_header: Utils.translate('Added to Cart'),

        template: multipleaddtocartplpConfirmationTpl,

        getLines: function getLines() {
            return _.map(LiveOrderModel.getInstance().get('latest_addition').split(',') || [], function mapLines(lineId) {
                return LiveOrderModel.getInstance().get('lines').get(lineId);
            });
        },

        initialize: function initialize() {
            this.linesAdded = new Backbone.Collection(this.getLines());
        },

        childViews: {
            'Collection.Items.Added': function CollectionItemsAdded() {
                return new BackboneCollectionView({
                    childView: MultipleAddToCartPLPCartConfirmationLineView,
                    collection: this.linesAdded,
                    viewsPerRow: 1
                });
            }
        }
    });
});
